
export type EnrollCourse201OneOfThreeResult = typeof EnrollCourse201OneOfThreeResult[keyof typeof EnrollCourse201OneOfThreeResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollCourse201OneOfThreeResult = {
  failed: 'failed',
} as const;
